import LatestNews from "./LatestNews";

export default LatestNews;
